/* BASIC COLORS */
// #181E34
export const COLOR_BLACK = 'rgba(24, 30, 52, 1)';
// #333D6C
export const COLOR_BLUE = 'rgba(51, 61, 108, 1)';
export const COLOR_BLUE_050 = 'rgba(51, 61, 108, 0.5)';
export const COLOR_BLUE_040 = 'rgba(51, 61, 108, 0.4)';
export const COLOR_BLUE_030 = 'rgba(51, 61, 108, 0.3)';
export const COLOR_BLUE_020 = 'rgba(51, 61, 108, 0.2)';
export const COLOR_BLUE_015 = 'rgba(51, 61, 108, 0.15)';
export const COLOR_BLUE_010 = 'rgba(51, 61, 108, 0.1)';
export const COLOR_BLUE_007 = 'rgba(51, 61, 108, 0.07)';
export const COLOR_BLUE_005 = 'rgba(51, 61, 108, 0.05)';

// #6AD5E5
export const COLOR_TURQUOISE = 'rgba(106, 213, 229, 1)';
export const COLOR_TURQUOISE_070 = 'rgba(106, 213, 229, 0.7)';
export const COLOR_TURQUOISE_050 = 'rgba(106, 213, 229, 0.5)';
export const COLOR_TURQUOISE_040 = 'rgba(106, 213, 229, 0.4)';
export const COLOR_TURQUOISE_020 = 'rgba(106, 213, 229, 0.2)';
// #FFFFFF
export const COLOR_WHITE = 'rgba(255, 255, 255, 1)';

// TODO:  NOT PROCESSED
// #FF335C
export const COLOR_RED = 'rgba(255, 51, 92, 1)';

export const COLOR_GREEN = 'rgba(106, 229, 159, 1)';
export const COLOR_GREEN_015 = 'rgba(106, 229, 159, 0.15)';
export const COLOR_YELLOW = 'rgba(245, 186, 66, 1)';
export const COLOR_MAGENTA = 'rgba(255,68,150,1)';
export const COLOR_VIOLET = 'rgba(131, 92, 179, 1)';
export const COLOR_VIOLET_015 = 'rgba(131, 92, 179, 0.15)';

/* TEXT COLORS */

export const COLOR_TEXT_GREY = 'rgba(24, 30, 52, 0.5)';
export const COLOR_TEXT_GREY_OB = 'rgba(177, 180, 200, 1)';
export const COLOR_TEXT_GREY_DISABLED = 'rgba(177, 180, 200, 0.5)';
export const COLOR_TEXT_PURPLE = 'rgba(71, 80, 123, 1)';

/* CONTEXT MENU */
export const COLOR_MENU_BACKGROUND = 'rgba(202, 204, 216, 0.3)';

/* BUTTON COLORS */
export const COLOR_BUTTON_PRIMARY = 'rgba(106, 213, 229, 1)';
export const COLOR_BUTTON_PRIMARY_050 = 'rgba(106, 213, 229, 0.5)';
export const COLOR_BUTTON_PRIMARY_070 = 'rgba(106, 213, 229, 0.7)';
export const COLOR_BUTTON_SECONDARY = 'rgba(50, 61, 111, 1)';

/* INPUT COLORS */
export const COLOR_INPUT_BACKGROUND = 'rgba(202, 204, 216, 0.3)';

/* SHADOWS */
export const COLOR_GREY_010 = 'rgba(24, 30, 52, 0.1)';
export const COLOR_GREY_015 = 'rgba(24, 30, 52, 0.15)';
export const COLOR_GREY_020 = 'rgba(24, 30, 52, 0.2)';
export const COLOR_GREY_040 = 'rgba(24, 30, 52, 0.4)';
export const COLOR_BOX_SHADOW = 'rgba(51,61,108, 0.1)';
export const COLOR_BUTTON_WARN_SHADOW = 'rgba(255, 51, 92,0.5)';

/* Boxes */
export const COLOR_BACKGROUND_GREY = 'rgba(245, 245, 247, 1)';
// #D7D9E2
export const COLOR_BORDER_GREY = 'rgba(215, 217, 226, 1)';
export const COLOR_PLACEHOLDER_GREY = 'rgba(241, 242, 245, 1)';

/* ??? */
export const COLOR_BACKGROUND_GREY_050 = 'rgba(239, 240, 243, 0.5)';
export const COLOR_BACKGROUND_GREY_25 = 'rgba(249, 249, 251, 0.5)';
export const COLOR_TEXT_PRIMARY_COLOR_06 = 'rgba(24,30,52,0.6)';

export const COLOR_DEEP_PURPLE = 'rgba(51, 61, 108, 1)';
